import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import classNames from 'classnames';
import { OFFSET_RANGE, OFFSET_CLASSES, SIZE_CLASSES, SCREEN_SIZES } from './UIGridConstants';

function makeBreakPointsType(range) {
  const rangePropType = PropTypes.oneOf(range);
  const screenSizeShapePropType = PropTypes.shape(SCREEN_SIZES.reduce((shape, screenSize) => {
    shape[screenSize] = rangePropType;
    return shape;
  }, {}));
  return PropTypes.oneOfType([PropTypes.string, // only intended for UIStepIndicator (#1753)
  rangePropType, screenSizeShapePropType]);
}

function breakPointsToClassName(classMap, breakPoints) {
  if (breakPoints == null) return null; // CRM-12024

  if (typeof breakPoints === 'string') {
    return null;
  }

  if (typeof breakPoints === 'number') {
    return classMap.xs[breakPoints];
  }

  return Object.keys(breakPoints).map(screenSize => {
    const value = breakPoints[screenSize];
    return `${classMap[screenSize][value]}`;
  }).join(' ');
}

const UIGridItem = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    offset,
    size
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "offset", "size"]);

  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    className: classNames(className, breakPointsToClassName(OFFSET_CLASSES, offset), breakPointsToClassName(SIZE_CLASSES, size)),
    ref: ref
  }));
});
UIGridItem.propTypes = {
  children: PropTypes.node,

  /**
   * The number of columns a UIGridItem should be offset by, or an object as described [here](/ui-library/show/UIComponents/grid/UIGrid#uigrid/basic).
   */
  offset: makeBreakPointsType(OFFSET_RANGE).isRequired,

  /**
   * The number of columns a UIGridItem should span, or an object as described [here](/ui-library/show/UIComponents/grid/UIGrid#uigrid/basic).
   */
  size: makeBreakPointsType(OFFSET_RANGE).isRequired
};
UIGridItem.defaultProps = {
  offset: 0
};
UIGridItem.displayName = 'UIGridItem';
export default UIGridItem;